<template>
  <div class="fill-height text-center d-flex flex-column justify-space-around px-6 all-container">
    <div class="success--text text--darken-2">
      <h1>{{ $t('GAME.RONDO.OVER') }}</h1>
      <h2>
        <ScoreDrawer :score="score" />
      </h2>
    </div>

    <div
      class="rondo-container d-flex justify-center"
      :class="{
        'rondo-container__small': $vuetify.breakpoint.smAndDown,
        'rondo-container__big': $vuetify.breakpoint.mdAndUp,
      }"
    >
      <!-- <ProfileRondo /> -->
      <!-- <GameRondo /> -->
      <GameRondo :class="{
        'rondo-small': $vuetify.breakpoint.smAndDown,
        'rondo-big': $vuetify.breakpoint.mdAndUp,
      }" />
    </div>

    <div>
      <BaseButton
        class="my-5"
        @click="$router.back()"
      >
        {{ $t('BACK') }}
      </BaseButton>
    </div>
  </div>
</template>

<style scoped>
.all-container {
  margin: auto;
  max-width: 500px;
  width: 100%;
}

.rondo-container {
  height: 200px;
}

.rondo-big {
  transform-origin: left top;
  transform: scale(1);
  position: absolute;
  margin-left: -180px;
  margin-top: -100px;
}

.rondo-small {
  transform-origin: left top;
  transform: scale(.4);
  position: absolute;
  margin-left: -72px;
}

/* Center rondo in mobile */
.rondo-container__small {
  margin-left: 265px;
}
.rondo-container__big {
  margin-top: 24px;
  margin-left: 165px;
}
</style>

<script>
import GameRondo from '@/components/games/rondo/GameRondo.vue';
import ScoreDrawer from '@/components/navigation/ScoreDrawer.vue';

export default {
  name: 'RondoGameOver',
  components: {
    GameRondo,
    ScoreDrawer,
  },
  computed: {
    score() {
      if (this.isClassMode) {
        return this.$store.getters['classMode/score']('rondo');
      }

      return this.$store.getters['rondo/score'];
    },
  },
};
</script>
